<template>
  <div class="card plan" :class="{'current': current && !store.user.state.user.guest, 'expiring': expiring}">
    <div class="plan-header">
      <h2>{{ name }}</h2>
    </div>
    <div class="plan-features">
      <div class="plan-feature" v-for="(feature, i) in features" :key="i">
        <AppIcon name="check" color="primary"/> <span v-html="feature"></span>
      </div>
    </div>
    <div class="divider"></div>
    <div class="plan-price">
      {{ price }} DKK <span v-if="price">/måned</span>
    </div>
    <div v-if="!store.user.state.user.guest">
      <AppButton v-if="expiring && planId !== 'FREE'" @click="$emit('reactivate')" color="warning">Fortsæt {{ name }}</AppButton>
      <AppButton v-else-if="current && planId !== 'FREE'" @click="$emit('unsubscribe')" color="error">Afmeld {{ name }}</AppButton>
      <AppButton v-else-if="!current" @click="$emit('subscribe')" color="primary">{{ getButton }}</AppButton>
      <small v-if="planId !== 'FREE'">Ingen binding.</small>
    </div>
    <small v-if="expiring" class="expiry-note color-warning"><b>Udløber {{$filters.date(subscription.current_period_end)}}</b></small>
  </div>
</template>

<script lang="ts">
import { Subscription } from '@/api/tripply/models'
import { defineComponent, computed, PropType } from 'vue'
import { store } from '@/store'

export default defineComponent({
  name: 'SubscriptionPlan',
  emits: ['subscribe', 'unsubscribe', 'reactivate'],
  props: {
    name: String,
    planId: String,
    price: Number,
    subscription: {
      type: Object as PropType<Subscription>,
      required: true
    },
    features: Array,
    getButton: String
  },
  setup(props) {
    
    const current = computed(() => props.subscription.planId == props.planId)
    const expiring = computed(() => current.value && props.subscription.expiring)
    
    return { store, expiring, current }
  }
})
</script>

<style lang="scss" scoped>
#plans {
  display: flex;

  .plan {
    width: 100%;
    max-width: 18rem;
    margin: 0 1.5rem 0 0;
    padding: 1.5rem;
    border-radius: 1.5rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    border: 4px solid var(--color-divider);

    &:before {
      display: none;
      font-family: 'Material Icons';
      color: white;
      height: 2.5rem;
      width: 2.5rem;
      position: absolute;
      top: -1rem;
      right: -1rem;
      border-radius: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.75rem;
    }

    &.current {
      border: 4px solid var(--color-primary);
      &:before {
        content: 'check';
        display: flex;
        background: var(--color-primary);
      }
    }

    &.expiring {
      border: 4px solid var(--color-warning);
      &:before {
        content: 'alarm_on';
        display: flex;
        background: var(--color-warning);
      }
    }

    &-features {
      height: 100%;
    }
    &-feature {
      display: flex;
      margin: .25rem 0;
      .icon {
        margin-right: 1rem;
      }
    }
    &-price {
      font-size: 1.75rem;
      font-weight: bold;
      white-space: nowrap;
      margin-bottom: 1rem;
      span {
        font-size: 1rem;
        font-weight: normal;
      }
    }

    button {
      width: 100%;
      justify-content: center;
    }

    .expiry-note {
      position: absolute;
      bottom: .5rem;
      left: 0;
      right: 0;
      text-align: center;
    }
  }
}
</style>